import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9fff54e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "screen_page"
}
const _hoisted_2 = { class: "screen_l" }
const _hoisted_3 = { class: "l_nav_panel" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "screen_r"
}
const _hoisted_6 = {
  key: 0,
  class: "r_item_socrll"
}
const _hoisted_7 = { class: "r_item_box" }
const _hoisted_8 = {
  key: 1,
  class: "null_box"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无筛选数据", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "r_btn" }

import { reactive, toRaw, ref, onMounted, nextTick, watch } from 'vue'
import  menuTree from './menuTree.vue';
type TleftData={
    AliasName: string,
    Children: Array<TleftData>
    CoverUrl: string
    Id: string
    Name: string
}

type TProps = {
    leftData: Array<TleftData>
    PageType: number //页面类型 1=精品课程 4=试题试卷
    IsHome: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    leftData: null,
    PageType: null,
    IsHome: null
  },
  emits: ['gradeMenu', 'okMenu'],
  setup(__props: any, { emit }) {

const prop = __props as {
    leftData: Array<TleftData>
    PageType: number //页面类型 1=精品课程 4=试题试卷
    IsHome: number
};

let person: any = reactive({
    gradeList:[], // 年级及以下列表
    gradeActive: 0, // 年级筛选
    gradeActiveIndex: 0, // 年级筛选
    subjectActive: -1, // 科目筛选
    isShowRight:false, // 是否显示右侧
    rightList: [], // 右侧一级列表
    lastId:0,
    rightIds:[],
    subjectId:0, // 科目Id
    subjectList:[],
    cache:''
})


let prs = toRaw(prop)
person.gradeList = prs.leftData

console.log('PageType', prop.PageType);


onMounted(async ()=>{
    // await subjectChange(person.gradeList[0], 0)
    await inIntClick()
})
const inIntClick = () => {
    //取缓存
    if ((prop.PageType === 1 || prop.PageType === 2) && prop.IsHome===0) {
        person.cache = localStorage.getItem('clickRecord')
    } else if ((prop.PageType === 3 || prop.PageType === 4) && prop.IsHome === 0) {
        person.cache = localStorage.getItem('clickRecord1')
    }
    if (person.cache !== '' && person.cache !== null) {
        var arr = JSON.parse(person.cache)
        // 初始化年级选中项
        person.gradeList.forEach((gra:any,index:any) => {
            if (gra.Id === arr[0].key){
                person.subjectActive = arr[0].key
                person.isShowRight = false
                person.rightList = gra.Children
            }
        });
    }
}
// 年级切换
const gradeChange=(item:any,index:number)=>{
    person.gradeActive = item.Id
    person.gradeActiveIndex = index
    person.isShowRight = false
    emit('gradeMenu', item)
    if (person.gradeActive !== item.Id) {
        MenuTree(item.ParentId, item.Id, item, -1, 1)
    } else {
        MenuTree(item.ParentId, item.Id, item, -1, 0)
    }
    person.subjectList=item.Children
}

// 科目切换
const subjectChange = (item: any, index: number) => {
    person.isShowRight = true
    if (item.Children && item.Children.length > 0) {
        person.rightList = item.Children
        person.subjectId = item.Id
    } else {
        person.rightList = []
    }
    if (person.subjectActive!==item.Id){
        MenuTree(item.ParentId, item.Id, item, -1, 1)
    }else{
        MenuTree(item.ParentId, item.Id, item, -1, 0)
    }
    person.subjectActive = item.Id
}
//index >0 表示的是 鼠标点击后的操作 index=0是表示存在缓存 默认绑定的数据 就是=0时 是不需要去修改缓存的
const MenuTree = (Pid: number, Id: number, item: any, riIndex: number, index:number) => {
    console.log('点击完成后', Id)
    person.lastId = Id
    person.riIndex = riIndex
    person.index = index
    // 判断当前点击的目录是否存在 如果存在 则替换
    if (index!==0){
        if (prop.PageType === 1 || prop.PageType === 2) {
            person.cache = localStorage.getItem('clickRecord')
        } else if (prop.PageType === 3|| prop.PageType === 4) {
            person.cache = localStorage.getItem('clickRecord1')
        }
        if (person.cache !== null && person.cache !== undefined && person.rightIds.length===0){
            person.rightIds = JSON.parse(person.cache)
        }
        person.rightIds = person.rightIds.filter((x:any)=>x.Pid!==Pid)
        person.rightIds = person.rightIds.filter((x:any)=>x.Index<riIndex)
        if (prop.PageType === 1) {
            person.rightIds.push({ 'Pid': Pid, 'key': Id, 'value': item, Index :riIndex, typeName: 1 })
        } else if (prop.PageType === 2) {
            person.rightIds.push({ 'Pid': Pid, 'key': Id, 'value': item, Index: riIndex, typeName: 2 })
        } else if (prop.PageType === 3) {
            person.rightIds.push({ 'Pid': Pid, 'key': Id, 'value': item, Index: riIndex, typeName: 3 })
        } else if (prop.PageType === 4) {
            person.rightIds.push({ 'Pid': Pid, 'key': Id, 'value': item, Index: riIndex, typeName: 4 })
        }
    }
};

// 确认筛选
const okClick=()=>{
    person.isShowRight = false
    let selectId = 0
    person.subjectId = person.gradeList.filter((x: any) => x.Id === person.subjectActive)[0].Id
    if (person.lastId>0){
        selectId = person.lastId
    } else if (person.subjectId>0){
        selectId = person.subjectId
    }
    emit('okMenu', selectId)
    person.lastId = 0
    if (prop.PageType === 1 || prop.PageType === 2) {
        localStorage.setItem('clickRecord', JSON.stringify(person.rightIds))
    }else if (prop.PageType === 3 || prop.PageType === 4) {
        localStorage.setItem('clickRecord1', JSON.stringify(person.rightIds))
    }
}
// 取消筛选
const cancelClick = () => {
    person.isShowRight = false
}

return (_ctx: any,_cache: any) => {
  const _component_CaretRight = _resolveComponent("CaretRight")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_unref(person).gradeList && _unref(person).gradeList.length>0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(person).gradeList, (chi, chiIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["panel_item", [_unref(person).subjectActive === chi.Id ?'panel_item_active':'']]),
                onClick: ($event: any) => (subjectChange(chi, chiIndex)),
                key: chiIndex
              }, [
                _createElementVNode("span", null, _toDisplayString(chi.Name), 1),
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_CaretRight)
                  ]),
                  _: 1
                })
              ], 10, _hoisted_4))
            }), 128))
          ])
        ]),
        (_unref(person).isShowRight)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_unref(person).rightList && _unref(person).rightList.length>0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(menuTree, {
                        menuList: _unref(person).rightList,
                        PageType: _unref(prop).PageType,
                        IsHome: _unref(prop).IsHome,
                        onMenuTree: MenuTree
                      }, null, 8, ["menuList", "PageType", "IsHome"])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10)),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_button, { onClick: okClick }, {
                  default: _withCtx(() => [
                    _createTextVNode("确定")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: cancelClick }, {
                  default: _withCtx(() => [
                    _createTextVNode("取消")
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})